'use client'

import { useEffect, useState } from 'react'

import { useUpFetch } from '../utils'

export const useFetchAvatar = (userId: number) => {
  const upFetch = useUpFetch()
  const [avatar, setAvatar] = useState<string | undefined>(undefined)

  useEffect(() => {
    const fetchAvatar = async () => {
      const user = await upFetch(`/users/${userId}`)
      setAvatar(user.data.avatar.url)
    }
    fetchAvatar()
  }, [])

  return { avatar }
}
